// client\src\pages\ViewCert\CertImg.js
import React from 'react';
import { Box } from '@mui/material';

function CertImg({ imageUrl }) {
    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                borderRadius: '12px',
            }}
        >
            <img
                src={imageUrl}
                alt="Certificate"
                style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    borderRadius: '12px',
                }}
            />
        </Box>
    );
}

export default CertImg;
